import React from "react";
import ImgAtendPsico from "../../../../assets/images/foto-destaque-atendimento-psicologico.jpg";
import ImgAtendPsico1 from "../../../../assets/images/foto-galeria-atendimento-psico-1.jpg";
import ImgAtendPsico2 from "../../../../assets/images/foto-galeria-atendimento-psico-2.jpg";
import Galery from "../../../../components/Galery";

const galeryImgs = [
  { src: ImgAtendPsico1, alt: "Aulas de Idiomas 1" },
  { src: ImgAtendPsico2, alt: "Aulas de Idiomas 2" },
];

const AtendimentoPsico = () => {
  return (
    <div className="detalhes-iniciativa">
      <main className="banner-detalhes-iniciativa-mobile bg-atendimento-peicologico" />

      <section className="detalhes-iniciativa-content container">
        <div className="row gutters">
          <div className="col grid_6">
            <h2 className="subtitulo-verde">Atendimento psicológico</h2>
            <p>
              Tratar a saúde mental das pessoas é entender seus sentimentos e
              orientá-las a compreender suas emoções, promovendo o bem-estar e o
              desenvolvimento pessoal.
            </p>
          </div>
          <div className="col grid_6">
            <img src={ImgAtendPsico} alt="Atendimento Psicológico" />
          </div>
        </div>
      </section>

      <Galery galeryImgs={galeryImgs} />
    </div>
  );
};

export default AtendimentoPsico;
